export default {"src":"/_next/static/media/arrow_down.c8e16b6a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};